import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { StatusDropdown } from "./status-dropdown";
import styles from "./change-status-modal.module.scss";
import CrossIcon from "../../../../../icons/cross.icon";

export const ChangeStatusModal = ({ show = false, onHide }) => {
  const [selectedStatus, setSelectedStatus] = useState("Mixed Statuses");
  const isStatusSelected = selectedStatus && selectedStatus !== "Mixed Statuses";

  const handleSave = () => {
    if (isStatusSelected) {
      // Handle save action
      console.log("Saving status:", selectedStatus);
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="change-status-modal-dialog"
      className={styles.modal}
      aria-labelledby="change-status-modal"
    >
      <Modal.Header className={styles.headerContainer}>
        <div className={styles.headerContent}>
          <div className={styles.closeButtonWrapper}>
            <button
              className={styles.closeButton}
              onClick={onHide}
              type="button"
            >
              <CrossIcon fill="#616778" width={11} height={11} />
            </button>
          </div>

          <div className={styles.titleWrapper}>
            <div className={styles.title}>
              Change Status
            </div>
          </div>
        </div>

        <div className={styles.dividerWrapper}>
          <div style={{ borderTop: "1px solid rgba(235, 237, 241, 1)", width: "100%" }} />
        </div>
      </Modal.Header>

      <Modal.Body className={styles.content}>
        <p className={styles.description}>
          Select the status you want to give to this accounts.
        </p>

        <div className={styles.statusContainer}>
          <div className={styles.statusLabel}>
            Status
          </div>

          <StatusDropdown 
            value={selectedStatus}
            onChange={setSelectedStatus}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <div className={styles.footerContent}>
          <button
            className={styles.cancelButton}
            onClick={onHide}
            type="button"
          >
            Cancel
          </button>
          <div className={styles.buttonGroup}>
            <button
              className={isStatusSelected ? styles.saveButton : `${styles.saveButton} ${styles.saveButtonDisabled}`}
              onClick={handleSave}
              disabled={!isStatusSelected}
              type="button"
            >
              Save
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};